import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import { COLOR } from 'config';

const StyledButton = styled(Button)`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  line-height: normal;
  padding-right: ${props => (props.px ? props.px : '1rem')};
  padding-left: ${props => (props.px ? props.px : '1rem')};
  vertical-align: middle;
  border-radius: ${props => props.borderRadius}px !important;
  width: ${props => (props.width ? props.width : 'auto')};
  color: ${COLOR.white} !important;
  background-color: ${props => props.backgroundColor};
  &:hover {
    background-color: ${props => props.backgroundColor};
  }
  font-weight: bold;
  margin-right: 8px;
  &:last-of-type {
    margin-right: 0;
  }
`;

const ComponentButton = ({
  children,
  to,
  big,
  borderRadius,
  backgroundColor,
  width,
  isHero,
  lineHeight,
  px,
}) => (
  <StyledButton
    big={big}
    bg={COLOR.base}
    width={width}
    mt={5}
    href={to}
    borderRadius={borderRadius}
    backgroundColor={backgroundColor}
    isHero={isHero}
    lineHeight={lineHeight}
    px={px}
    target="_blank"
    rel="noopener noreferrer"
  >
    {children}
  </StyledButton>
);

ComponentButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  to: PropTypes.string,
  big: PropTypes.bool,
  width: PropTypes.string,
  px: PropTypes.string,
  borderRadius: PropTypes.number,
  backgroundColor: PropTypes.string,
  isHero: PropTypes.bool.isRequired,
  lineHeight: PropTypes.number.isRequired,
};

ComponentButton.defaultProps = {
  to: '',
  big: false,
  borderRadius: 5,
  backgroundColor: COLOR.base,
  width: '160px',
  px: '1rem',
};

export default ComponentButton;



// WEBPACK FOOTER //
// ./src/components/NYCMeetUpLanding/components/Button.js